import { render } from "./GameResult.vue?vue&type=template&id=670e4e80&ts=true"
import script from "./GameResult.vue?vue&type=script&lang=ts"
export * from "./GameResult.vue?vue&type=script&lang=ts"

import "./GameResult.vue?vue&type=style&index=0&id=670e4e80&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__